export default "__VITE_ASSET__DcazQOuR__"